export default __webpack_public_path__ + "static/media/calendar.1e45cdd1.png";